import Stack from "@mui/material/Stack";

import { useStyles } from "../styles";

import { Bar } from "../../../components/Recharts/Bar";
import { Pie } from "../../../components/Recharts/Pie";
import WithoutInformation from "../../Home/WithoutInformation";
import { isEmpty } from "lodash";
import { PaperChart } from "../../../components/PaperChart";

type AnalyticsProps = {
  loading: boolean;
  day: any[];
  store: any[];
  hours: any[];
  genre: any[];
  ageGroup: any[];
};

export function Analytics({
  loading,
  ageGroup,
  day,
  genre,
  hours,
  store,
}: AnalyticsProps) {
  const styles = useStyles();

  return (
    <>
      <Stack spacing={4}>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Vendas por lojas"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(store) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="nome_loja"
                barDataKey="qtde_vendas"
                data={store}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>

          <PaperChart
            loading={loading}
            label="Vendas por dias"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(day) ? (
              //@ts-ignore
              <Bar
                barLegend
                xDataKey="DATA_ANALISE"
                barDataKey="qtde_vendas"
                data={day}
              />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
        <PaperChart
          loading={loading}
          label="Vendas por hora"
          className={styles.paperCreatedDay}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(hours) ? (
            //@ts-ignore
            <Bar
              barLegend
              xDataKey="HORA_ANALISE"
              barDataKey="qtde_vendas"
              data={hours}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <PaperChart
            loading={loading}
            label="Gênero"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(genre) ? (
              <Pie nameKey="name" dataKey="value" data={genre} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>

          <PaperChart
            loading={loading}
            label="Faixa etária"
            className={styles.paperCharts}
            variant="outlined"
            elevation={0}
          >
            {!isEmpty(ageGroup) ? (
              <Pie nameKey="name" dataKey="value" data={ageGroup} />
            ) : (
              <WithoutInformation />
            )}
          </PaperChart>
        </Stack>
      </Stack>
    </>
  );
}
